import ActionsList from 'cohabitation/components/list/actions-list';
import { CommonCohabitationCrumbs } from 'cohabitation/constants/breadcrumb';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import SearchCohabitation from 'shell/components/shared/search-cohabitation';

export default function CohabitationSearchPage(): React.ReactElement {
  return (
    <>
      <Breadcrumbs items={CommonCohabitationCrumbs} base="convivenza" />
      <SearchCohabitation action={ActionsList} />
    </>
  );
}

CohabitationSearchPage.displayName = 'search cohabitation home page component';
